import React, { createContext, useContext } from 'react';

export interface ClassMembersSettingsModalContextValue {
  openClassMembersSettingsModal: () => void;
}

export const ClassMembersSettingsModalContext =
  createContext<ClassMembersSettingsModalContextValue | null>(null);

/** MainLayout 밖에서는 null. 호출부에서 null 체크 후 사용 */
export function useClassMembersSettingsModal(): ClassMembersSettingsModalContextValue | null {
  return useContext(ClassMembersSettingsModalContext);
}
